import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';

import './ButtonCustom.css';

const ButtonCustom = (props) => {
  const disabledClass = (props.isDisabled) ? 'disabled-bttn' : '';
  const customClassName = `custom-bttn-styles ${props.colorClass} ${props.customClass} ${disabledClass}`;

  const onClickAction = () => {
    const { activeElement } = document;

    if(activeElement) activeElement.blur();

    props.clickAction();
  }

  return (
    <Button
      className={customClassName}
      onClick={onClickAction}
      data-test-id={props.dataTestLabel}
      tabIndex={props.tabIndex}
      disabled={props.isDisabled}
    >
      {props.iconClass === 'create-icon' && <span className="icon-plus" />}
      {props.iconClass === 'eye-icon' && <span className="icon-eye" />}
      {props.iconClass === 'person-icon' && <span className="icon-rooming_list" />}
      {props.iconClass === 'list-icon' && <span className="icon-list" />}
      {props.iconClass === 'excel-icon' && <span className="icon-excel" />}
      {props.iconClass === 'comment-icon' && <span className="icon-comment" />}
      <span>{props.label}</span>
    </Button>
  );
};

ButtonCustom.propTypes = {
  label: PropTypes.string.isRequired,
  colorClass: PropTypes.string,
  customClass: PropTypes.string,
  iconClass: PropTypes.string,
  dataTestLabel: PropTypes.string,
  isDisabled: PropTypes.bool,
  tabIndex: PropTypes.string,
  clickAction: PropTypes.func
};

ButtonCustom.defaultProps = {
  colorClass: '',
  customClass: '',
  iconClass: '',
  dataTestLabel: 'data-test-id-button',
  isDisabled: false,
  tabIndex: '',
  clickAction: () => {}
};

export default ButtonCustom;
